import { templateService } from "../Services/TemplateService.ts";

export const handleCreateTemplate = async (payload): Promise<any> => {
  try {
    const response = await templateService.createTemplate(payload);
    return response.data;
  } catch (error: any) {
    console.error("Error creating template:", error);
    throw error;
  }
};

export const handleFetchTemplate = async (skip = 0, limit = 10, page = 1): Promise<any> => {
  try {
    const response = await templateService.getTemplateData(skip,limit, page);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching template list:", error);
    throw new Error("Failed to fetch template.");
  }
};

export const handleFetchTable = async (skip = 0, limit = 10, page = 1): Promise<any> => {
  try {
    const response = await templateService.getTableData(skip,limit, page);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching table list:", error);
    throw new Error("Failed to fetch table.");
  }
};

export const handleFetchTablePreview = async (table_name): Promise<any> => {
  try {
    const response = await templateService.getTablePreviewData(table_name);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching table preview:", error);
    throw new Error("Failed to fetch table preview.");
  }
};

export const handleDeleteTemplate = async (
  templateId: number
): Promise<void> => {
  try {
    await templateService.deleteTemplateData(templateId);
  } catch (error: any) {
    console.error("Error deleting template:", error);
    throw new Error(
      error.response?.data?.detail || "Failed to delete template"
    );
  }
};
export const handleFetchTemplateByid = async (templateId): Promise<any> => {
  try {
    const response = await templateService.getTemplateDataByid(templateId);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching template list:", error);
    throw new Error("Failed to fetch template.");
  }
};

export const handleEditTemplate = async (templateId: number, payload: any): Promise<any> => {
  try {
    const response = await templateService.editTemplateData(templateId, payload);
    return response.data;
  } catch (error: any) {
    console.error("Error updating template:", error);
    throw error;
  }
};